import { create } from "zustand";
import { persist } from "zustand/middleware";

import { ExpandableWrapperTitleCodes } from "~/common/utils/types/summariesExpandableIdsTypes";
import {
  ALL_AI_CONVERSATION_HISTORY_CODES,
  ALL_TREATMENT_RECOMMENDATIONS_CODES,
  PREVIEW_TITLE_CODES,
} from "../constants/SummariesExpandableIds";

interface setExpandedSectionsProps {
  code: (typeof PREVIEW_TITLE_CODES)[keyof typeof PREVIEW_TITLE_CODES];
  sections: string[];
}

export interface UsePreviewStoreProps {
  expandedSections: Record<ExpandableWrapperTitleCodes, string[]>;
  setExpandedSections: ({ code, sections }: setExpandedSectionsProps) => void;
  patientId?: string;
  setPatientId(patientId: string): void;
  reset: () => void;
}

const defaultValues = {
  patientId: undefined,
  expandedSections: {
    [PREVIEW_TITLE_CODES.FUNCTIONAL_DOMAINS]: [],
    [PREVIEW_TITLE_CODES.HEALTH_HISTORY]: [],
    [PREVIEW_TITLE_CODES.PERSONAL_LIFE_HISTORY]: [],
    [PREVIEW_TITLE_CODES.TREATMENT_RECOMMENDATIONS]: [
      ...ALL_TREATMENT_RECOMMENDATIONS_CODES,
    ],
    [PREVIEW_TITLE_CODES.AI_CONVERSATION_HISTORY]: [
      ...ALL_AI_CONVERSATION_HISTORY_CODES,
    ],
  },
};

export const usePreviewStore = create<UsePreviewStoreProps>()(
  persist(
    (set) => ({
      ...defaultValues,
      setExpandedSections: ({ code, sections }: setExpandedSectionsProps) => {
        set((state) => ({
          expandedSections: {
            ...state.expandedSections,
            [code]: sections,
          },
        }));
      },

      setPatientId: (patientId: string) => {
        set(() => ({ patientId }));
      },
      reset: () => set(defaultValues),
    }),
    {
      name: "usePreviewStore",
    },
  ),
);
